import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AUTH_STATE_KEY, IAuthState } from '../reducers/auth.reducer';
import { IUserAuthProfile } from '../../services';

const authState = createFeatureSelector<IAuthState>(AUTH_STATE_KEY);

const isAuthenticated = createSelector(authState, ({ authenticated }) => authenticated);
const discoveryDocumentLoaded = createSelector(authState, ({ discoveryDocumentLoaded }) => discoveryDocumentLoaded);
const userAuthProfile = createSelector(authState, ({ userProfile }) => userProfile);
const userName = createSelector(userAuthProfile, ({ preferred_username }) => preferred_username);
const userId = createSelector(userAuthProfile, ({ 'user-id': userId }) => userId);
const userProfileLoaded = createSelector(authState, ({ userProfileLoaded }) => userProfileLoaded);
const exagoRole = createSelector(userAuthProfile, ({ ExagoRole }): string => {
  const roleName = Array.isArray(ExagoRole) ? ExagoRole[0] : ExagoRole;

  return roleName || '';
});
const hasExagoRole = createSelector(userAuthProfile, (profile: IUserAuthProfile): boolean => 'ExagoRole' in profile);

export const AUTH_SELECTORS = {
  isAuthenticated,
  discoveryDocumentLoaded,
  userAuthProfile,
  userName,
  userId,
  userProfileLoaded,
  exagoRole,
  hasExagoRole,
};
